import React from 'react';
import {Redirect} from 'react-router';
import {NavLink} from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";

import ImageUpload from "components/CustomUpload/ImageUpload.jsx";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import CardFooter from "components/Card/CardFooter.jsx";
import {
    verifyEmail,
    verifyPhoneNumber,
    verifyNumber,
    verifyAlphaNum,
    verifyName,
    isClinicMasterOrClinic,
    getClinicUserId,
    clinicmaster_id, dashboardRouter
} from '../../../util/globalHelper';

import api from "../../../api/Api";

// style for this view
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Loader from "../../Loader";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

class ValidationForms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            age: "",
            ageState: "",
            gender: "male",
            dob: "",
            dobState: "",
            phoneNumberState: "",
            phoneNumber: "",
            registerEmail: "",
            registerEmailState: "",
            imageurl: "",
            allergies: [],
            diseases: [],
            bloodGroup: "",
            bloodGroupState: "",
            height: "",
            heightState: "",
            weight: "",
            weightState: "",
            BMI: "",
            BMIState: "",
            medication: [],
            doctor_ids: [],
            appointment_ids: [],
            report_ids: [],
            alert: null,
            open: true,
            redirect: false,
            nameState: "",
            last_nameState: "",
            name: "",
            last_name: "",
            clinicmaster_id: "",
            clinic_id: "",
            data: null,
            clinicsData: null


        };
        this.hideAlert = this.hideAlert.bind(this);
        this.typeClick = this.typeClick.bind(this);
        this.CreateAlertonADD = this.CreateAlertonADD.bind(this);
        this.handleChangeGender = this.handleChangeGender.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
    }


    componentDidUpdate() {
    }

    componentDidMount() {
        this.CallReadApi()
    }


    CreateAlertonADD(reason) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{reason}</DialogTitle>

                    <DialogActions>
                        <Button onClick={this.hideAlert}>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }


    handleImageUrl(url) {
        this.setState({imageurl: url});
    }


    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };


    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                } else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }


    CallCreateApi(data) {
        api.addNewPatient(data)
            .then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    this.setState({redirect: true});
                    var msgcolor = {message: "Patient Added Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                }
            }).catch(error => {
            var msgcolor = {message: "Server Error!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        })
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }

    handleChangeGender(event) {
        this.setState({
            gender: event.target.value
        });
    }

    setGender(event) {
        this.setState({gender: event.target.value})
    }

    typeClick() {
        if (this.state.name === "") {
            this.setState({nameState: "error"});
            this.props.id.generateNotification({message: "Please fill the name!", color: "danger"});
        }
        /*else if (this.state.registerEmail === "") {
            this.setState({registerEmailState: "error"});
            this.props.id.generateNotification({message: "Please fill the email!", color: "danger"});

        }*/
        else if (this.state.phoneNumberState === "") {
            this.setState({phoneNumberState: "error"});
            this.props.id.generateNotification({message: "Please fill the number!", color: "danger"});
        } else if (this.state.clinicmaster_id == null || this.state.clinicmaster_id === "") {
            //this.setState({nameState: "error"});
            this.props.id.generateNotification({message: "Please select the clinic master!", color: "danger"});

        } else if (this.state.clinic_id == null || this.state.clinic_id === "") {
            //this.setState({nameState: "error"});
            this.props.id.generateNotification({message: "Please select the clinic!", color: "danger"});

        } else if (this.state.dobState == "error" && this.state.bloodGroupState == "error" && this.state.weightState == "error") {
            // this.setState({nameState: "error"});
            this.props.id.generateNotification({message: "Please add personal details!", color: "danger"});

        } else if (this.state.nameState === "success" &&
            this.state.phoneNumberState === "success" &&
            this.state.ageState !== "error" &&
            this.state.registerEmailState !== "error" && this.state.dobState !== "error" && this.state.bloodGroupState !== "error" && this.state.weightState !== "error") {
            var data = {
                name: this.state.name,
                age: this.state.age,
                gender: this.state.gender,
                dob: this.state.dob,
                contact: this.state.phoneNumber,
                email: this.state.registerEmail,
                profile_image: this.state.imageurl,
                allergies: [],
                diseases: [],
                blood_group: this.state.bloodGroup,
                height: this.state.height,
                weight: this.state.weight,
                BMI: this.state.BMI,
                medications: [],
                doctor_ids: [],
                appointment_ids: [],
                report_ids: [],
                clinic_master_id: this.state.clinicmaster_id,
                clinic_id: this.state.clinic_id
            };
            this.CallCreateApi(data);
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }


    render() {
        const {classes} = this.props;
        const {data, clinicsData} = this.state;
        if ((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && this.state.clinicsData[0] !== null && (this.state.clinicsData === [null] || this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id))) {
            this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id)
        }
        if (this.state.redirect) {
            return <Redirect to={{pathname: "/patient/readPatients"}}/>;
        }
        if (this.state.data)
            return (
                <div>
                    {this.state.alert}
                    <GridContainer className={classes.justifyContentCenter}>
                        <GridItem xs={12} sm={12} md={12}>
                            <form>
                                <GridContainer className={classes.justifyContentCenter}>
                                    <GridItem xs={12} sm={7} md={5}>
                                        <CustomInput
                                            labelText="Name"
                                            id="name"
                                            success={this.state.nameState === "success"}
                                            error={this.state.nameState === "error"}
                                            formControlProps={{
                                                fullWidth: true,
                                                required: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "name", "name", "required")
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={7} md={5}>
                                        <CustomInput
                                            success={this.state.registerEmailState === "success"}
                                            error={this.state.registerEmailState === "error"}
                                            labelText="Email "
                                            id="registeremail"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "registerEmail", "email", "optional"),
                                                type: "email"
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={7} md={5}>
                                        <CustomInput
                                            labelText="Phone Number"
                                            success={this.state.phoneNumberState === "success"}
                                            error={this.state.phoneNumberState === "error"}
                                            id="phonenumber"
                                            formControlProps={{
                                                fullWidth: true,
                                                required: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "phoneNumber", "phonenumber", "required")
                                            }}
                                        />
                                    </GridItem>

                                    <GridItem xs={12} sm={7} md={5}>
                                        <CustomInput
                                            labelText="Age"
                                            success={this.state.ageState === "success"}
                                            error={this.state.ageState === "error"}
                                            id="age"
                                            formControlProps={{
                                                fullWidth: true,
                                                required: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "age", "novalidation", "optional")
                                            }}
                                        />
                                    </GridItem>

                                </GridContainer>
                                <GridContainer className={classes.justifyContentCenter}>
                                    <GridItem xs={12} sm={7} md={5}>
                                        <p><b>Gender:</b></p>
                                        <RadioGroup aria-label="position" name="position" value={this.state.gender}
                                                    onChange={this.handleChangeGender} row>
                                            <FormControlLabel
                                                value="M"
                                                control={<Radio color="primary"/>}
                                                label="Male"
                                                labelPlacement="end"
                                            />
                                            <FormControlLabel
                                                value="F"
                                                control={<Radio color="primary"/>}
                                                label="Female"
                                                labelPlacement="end"
                                            />
                                        </RadioGroup>
                                    </GridItem>
                                    <GridItem xs={12} sm={7} md={5}>
                                        <CustomInput
                                            labelText="Date Of Birth"
                                            success={this.state.dobState === "success"}
                                            error={this.state.dobState === "error"}
                                            id="dob"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "dob", "novalidation", "optional")
                                            }}
                                        />
                                    </GridItem>

                                    <GridItem xs={12} sm={7} md={5}>
                                        <CustomInput
                                            labelText="Height"
                                            success={this.state.heightState === "success"}
                                            error={this.state.heightState === "error"}
                                            id="bloodGroup"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "height", "novalidation", "optional")
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={7} md={5}>
                                        <CustomInput
                                            labelText="Weight"
                                            success={this.state.weightState === "success"}
                                            error={this.state.weightState === "error"}
                                            id="weight"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "weight", "novalidation", "optional")
                                            }}
                                        />
                                    </GridItem>


                                    <GridItem xs={12} sm={7} md={5}>
                                        <CustomInput
                                            labelText="Blood Group"
                                            success={this.state.bloodGroupState === "success"}
                                            error={this.state.bloodGroupState === "error"}
                                            id="bloodGroup"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "bloodGroup", "novalidation", "optional")
                                            }}
                                        />
                                    </GridItem>


                                    <GridItem xs={12} sm={7} md={5}>
                                        <CustomInput
                                            labelText="BMI"
                                            success={this.state.BMIState === "success"}
                                            error={this.state.BMIState === "error"}
                                            id="BMI"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                onChange: event =>
                                                    this.change(event, "BMI", "novalidation", "optional")
                                            }}
                                        />
                                    </GridItem>

                                    {/*<GridItem xs={12} sm={7} md={5}>
                                        <legend>Allergies</legend>
                                        <GridItem xs={12} sm={12} md={12}>

                                        </GridItem>
                                    </GridItem>*/}

                                    {isClinicMasterOrClinic() === "" ? <GridItem xs={12} sm={7} md={5}>
                                        <FormControl
                                            fullWidth
                                            className={classes.selectFormControl}>
                                            <InputLabel
                                                htmlFor="clinicmaster_id"
                                                className={classes.selectLabel}>
                                                Clinic Master
                                            </InputLabel>
                                            <Select
                                                MenuProps={{
                                                    className: classes.selectMenu
                                                }}
                                                classes={{
                                                    select: classes.select
                                                }}
                                                value={this.state.clinicmaster_id}
                                                onChange={this.onChangeSelect}
                                                inputProps={{
                                                    name: "clinicmaster_id",
                                                    id: "clinicmaster_id"
                                                }}
                                            >
                                                <MenuItem
                                                    disabled
                                                    classes={{
                                                        root: classes.selectMenuItem
                                                    }}>
                                                    Select Clinic
                                                </MenuItem>
                                                {data.map((x) => {
                                                    return <MenuItem key={Math.random()}
                                                                     classes={{root: classes.selectMenuItem}}
                                                                     style={{height: "1.8em"}}
                                                                     value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                })}
                                            </Select>
                                        </FormControl>
                                    </GridItem> : null}

                                    <GridItem xs={12} sm={7} md={5}>
                                        {(isClinicMasterOrClinic() === "" || isClinicMasterOrClinic()) && this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?

                                            <FormControl
                                                fullWidth
                                                className={classes.selectFormControl}>
                                                <InputLabel
                                                    htmlFor="clinic_id"
                                                    className={classes.selectLabel}>
                                                    Clinic
                                                </InputLabel>
                                                <Select
                                                    MenuProps={{
                                                        className: classes.selectMenu
                                                    }}
                                                    classes={{
                                                        select: classes.select
                                                    }}
                                                    value={this.state.clinic_id}
                                                    onChange={this.onChangeSelect}
                                                    inputProps={{
                                                        name: "clinic_id",
                                                        id: "clinic_id"
                                                    }}
                                                >
                                                    <MenuItem
                                                        disabled
                                                        classes={{
                                                            root: classes.selectMenuItem
                                                        }}>
                                                        Select Clinic
                                                    </MenuItem>
                                                    {clinicsData.map((x) => {
                                                        return <MenuItem key={Math.random()}
                                                                         classes={{root: classes.selectMenuItem}}
                                                                         style={{height: "1.8em"}}
                                                                         value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl> : null}
                                    </GridItem>

                                </GridContainer>
                            </form>
                            <GridContainer className={classes.justifyContentCenter} style={{marginTop: '30px'}}>

                                <GridItem xs={12} sm={3} md={2}>
                                    <br/>
                                    <legend>Image</legend>
                                    <br/>
                                </GridItem>
                                <GridItem xs={12} sm={4} md={3}>
                                    <ImageUpload
                                        addButtonProps={{
                                            color: "warning",
                                            round: false
                                        }}
                                        changeButtonProps={{
                                            color: "warning",
                                            round: false
                                        }}
                                        removeButtonProps={{
                                            color: "grey",
                                            round: false
                                        }}
                                        handleImageUrl={this.handleImageUrl.bind(this)}
                                        role="Patient"
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={7} md={5}></GridItem>
                            </GridContainer>

                            <CardFooter className={classes.justifyContentCenter}>
                                <GridItem xs={12} sm={3} md={2}>
                                    <Button block color="warning" onClick={this.typeClick}>
                                        Add
                                    </Button>
                                </GridItem>
                                <GridItem xs={12} sm={3} md={2}>
                                    <NavLink to={dashboardRouter("/patient/readPatients")}>
                                        <Button block color="default">
                                            Cancel
                                        </Button>
                                    </NavLink>
                                </GridItem>
                            </CardFooter>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        else
            return (
                <div>
                    <Loader/>
                    <br/>
                </div>
            )
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    CallReadApi = () => {
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({data: json.data.data})
        }) : this.setState({data: {}, clinicmaster_id: clinicmaster_id(), clinic_id: getClinicUserId()});
    };

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        });
    }

}

export default withStyles(validationFormsStyle, extendedFormsStyle)(ValidationForms);



// WEBPACK FOOTER //
// ./src/components/Forms/PatientForm/PatientForm.jsx